import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        {/* Top - Text Area */}
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-20 mb-12">
          <div className="lg:w-[35%]">
            <p className="text-xs font-semibold text-accent-600 uppercase tracking-wider mb-4">
              O autorze
            </p>
          </div>
          <div className="lg:w-[65%]">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight mb-6">
              Ekspert ds. danych z ponad 5-letnim doświadczeniem w analizie arkuszy kalkulacyjnych
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mb-3">
              Autor przeanalizował ponad 100 różnych rozwiązań związanych z arkuszami kalkulacyjnymi, w tym usfansspreadsheet, aby dostarczyć Ci rzetelnych i sprawdzonych informacji. Każdy artykuł jest weryfikowany przez specjalistę ds. bezpieczeństwa danych.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              Naszym celem jest dostarczenie kompletnego przewodnika po usfansspreadsheet — od podstawowych funkcji po zaawansowane porównania z konkurencyjnymi narzędziami. Wszystkie treści mają charakter informacyjny i są regularnie aktualizowane.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <Link
                to="/artykul/co-to-jest-usfansspreadsheet"
                className="text-sm font-medium text-accent-700 hover:text-accent-800 underline underline-offset-4 transition-colors cursor-pointer"
              >
                Przeczytaj przewodnik &rarr;
              </Link>
              <span className="text-xs text-foreground-400 flex items-center gap-1.5">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-line text-xs text-accent-500"></i>
                </div>
                Zweryfikowane przez eksperta
              </span>
            </div>
          </div>
        </div>

        {/* Bottom - Dual Images */}
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="sm:w-[40%] h-64 md:h-80 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20data%20analyst%20at%20modern%20desk%20with%20multiple%20screens%20showing%20charts%20and%20graphs%2C%20concentrated%20work%2C%20warm%20office%20lighting%2C%20clean%20minimalist%20setup%2C%20editorial%20corporate%20portrait%20style%2C%20natural%20expression&width=800&height=1000&seq=about-left-v2-01&orientation=portrait"
              alt="usfansspreadsheet - analityk danych"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="sm:w-[60%] h-64 md:h-80 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Team%20of%20professionals%20collaborating%20around%20large%20digital%20whiteboard%20with%20sticky%20notes%20and%20charts%2C%20modern%20glass%20meeting%20room%2C%20bright%20natural%20daylight%2C%20creative%20brainstorming%20session%2C%20editorial%20business%20photography&width=1200&height=800&seq=about-right-v2-02&orientation=landscape"
              alt="usfansspreadsheet - zespół analityczny"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}